import { isNotDefined } from '@sgme/fp';
import { FormattedMessage } from 'react-intl';

import { useAlgoTileId, useValidateAlgo } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { useAppDispatch, useAppSelector } from '@/store/hooks.ts';
import { ordersSlice } from '@/store/orders/slice.ts';

const BackButton = ({ readOnly, currencyPair }: { readOnly: boolean; currencyPair: string }) => {
  const dispatch = useAppDispatch();
  const userPreferences = useAppSelector((state) => state.userPreferences);

  const tileId = useAlgoTileId();
  const validateAlgo = useValidateAlgo();

  function resetOrder() {
    dispatch(ordersSlice.actions.resetOrder({ tileId, userPreferences }));
    const [currency1, currency2] = currencyPair.split('/');

    if (isNotDefined(tileId) || isNotDefined(currency1) || isNotDefined(currency2)) {
      console.error('Invalid currency pair:', currencyPair);
      return;
    }

    validateAlgo({
      currencyPair: {
        currency1,
        currency2,
      },
    });
  }
  return (
    <button
      type="button"
      className="btn btn-sm btn-discreet-secondary btn-icon-text gap-4px p-8px"
      onClick={resetOrder}
      data-e2e="reset-btn"
      disabled={readOnly}
    >
      <em className="icon icon-sm">restart_alt</em>
      <FormattedMessage id="order.result.back" />
    </button>
  );
};

export default BackButton;
